import {
  API_ENDPOINT,
  useClientApiV1NotesIdMetadataQuery,
} from '../../../../../../resources/@types/uccSchema';

function useNoteIdMetadataQuery(
  id: string,
  options?: Parameters<typeof useClientApiV1NotesIdMetadataQuery>[0]['options'],
) {
  return useClientApiV1NotesIdMetadataQuery({
    queryKey: getUseNoteIdMetadataQueryKey(id),
    url: API_ENDPOINT.CLIENT_V1_NOTES_ID_METADATA(id),
    options: {
      staleTime: Infinity,
      ...options,
    },
  });
}

export const getUseNoteIdMetadataQueryKey = (id: string) => [
  API_ENDPOINT.CLIENT_V1_NOTES_ID_METADATA(id),
];

export default useNoteIdMetadataQuery;
